import React from 'react';

const parseAmenities = dataArray => {
  const arrayLength = dataArray.length
  if (arrayLength < 3) {
    return [dataArray]
  }

  const _dataArray = [...dataArray];
  const arraySize = Math.floor(arrayLength / 3)
  const result = []
  while (_dataArray.length) {
    result.push(_dataArray.splice(0, arraySize))

  }
  return result
}

const Amenities = ({ amenities }) => {
  return (
    <div className="row amenities">
      {Array.isArray(amenities) && parseAmenities(amenities).map(subAmenities => (
        <div key={`${subAmenities[0]}-parent`} className="col-lg-4 col-md-6">
          <div className="ltn__menu-widget">
            <ul>
              {subAmenities.map(ameniti => (
                <li key={ameniti}>
                  <label className="checkbox-item">{ameniti}
                    <input type="checkbox" defaultChecked="checked" />
                    <span className="checkmark" />
                  </label>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Amenities;
